<div class="page-transition">

  <!-- Banner -->
  <div class="relative h-[200px] sm:h-[300px] md:h-[400px] overflow-hidden">
    <img src="assets/images/static-banner/partner.jpg"
      alt="Printing Partner"
      class="w-full h-full object-cover" />
  </div>

  <!-- Content Area -->
  <section class="py-8 md:py-12 bg-white">
    <div class="max-w-[1200px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row gap-8 lg:gap-10">

      <!-- LEFT: Heading + Form (65%) -->
      <div class="lg:w-[63%]">
        <h1 class="text-xl md:text-2xl font-semibold text-gray-900 text-center leading-snug mb-2">Need A Printing & Framing Partner For Your Projects Like Exhibition/Events/Others ?</h1>
        <div class="flex items-center justify-center gap-2 mb-5">
          <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]/40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
          <div class="w-8 h-[1.5px] bg-[#600b0b]/30"></div>
        </div>

        <p class="text-sm text-gray-500 text-center mb-1">Register & Get a Sample of your Own Picture + Print Surface Catalogue Free *.</p>
        <p class="text-sm text-gray-500 text-center mb-6">Share your project requirement with us. Our team of experts will contact you within 48-Hours.</p>

        <!-- Form -->
        <form [formGroup]="form" (ngSubmit)="submit()" class="border-2 border-[#600b0b] rounded-2xl p-5 md:p-8">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">

            <input formControlName="name" type="text" placeholder="Name *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <input formControlName="email" type="email" placeholder="Email *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <input formControlName="contact" type="text" maxlength="10" placeholder="Contact Number *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <input formControlName="password" type="password" placeholder="Password *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <select formControlName="i_am"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('i_am')?.value">
              <option value="" disabled class="text-gray-400">I Am *</option>
              <option *ngFor="let opt of iAmOptions" [value]="opt" class="text-gray-800">{{ opt }}</option>
            </select>

            <input formControlName="city" type="text" placeholder="City *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <input formControlName="state" type="text" placeholder="State *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />

            <select formControlName="requirement"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors text-gray-400 appearance-none cursor-pointer"
              style="background-image:url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23999%27 stroke-width=%272%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right 4px center;"
              [class.text-gray-800]="form.get('requirement')?.value">
              <option value="" disabled class="text-gray-400">Requirement *</option>
              <option *ngFor="let r of requirementOptions" [value]="r" class="text-gray-800">{{ r }}</option>
            </select>
          </div>

          <div class="mt-7 text-center">
            <button type="submit" [disabled]="form.invalid || isSubmitting"
              class="bg-[#600b0b] text-white px-10 py-3 rounded text-sm font-bold hover:bg-[#8c1c1c] disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              {{ isSubmitting ? 'Submitting...' : 'Submit' }}
            </button>
          </div>
        </form>
      </div>

      <!-- RIGHT: Why + Contact (35%) -->
      <div class="lg:w-[37%]">

        <!-- Why Printing -->
        <h2 class="text-lg md:text-xl font-semibold text-gray-900 mb-2">Why Printing And Framing With Mahatta Art?</h2>
        <div class="flex items-center gap-2 mb-5">
          <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
          <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
        </div>

        <ul class="space-y-3 mb-8">
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">High Quality archival print surfaces used- Matte, Luster, Fine Art, Canvas etc.</span>
          </li>
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">Giclee Printing- Epson Printing technology used.</span>
          </li>
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">Premium archival ink in 8 colors to provide luxurious prints with wide color spectrum.</span>
          </li>
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">The smooth transitions of color gradients make Giclee prints appear much more realistic than other prints.</span>
          </li>
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">The archival inks used guaranteed lightfast in normal conditions for in excess of 25 years.</span>
          </li>
          <li class="flex gap-2 items-start">
            <span class="w-1.5 h-1.5 rounded-full bg-[#600b0b] shrink-0 mt-1.5"></span>
            <span class="text-sm font-semibold text-[#600b0b]">Prints look 99.9% similar to original art.</span>
          </li>
        </ul>

        <!-- Contact Information -->
        <h2 class="text-lg md:text-xl font-semibold text-gray-900 mb-2">Contact Information</h2>
        <div class="flex items-center gap-2 mb-4">
          <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]/30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="7" height="7" transform="rotate(45 6.5 6.5)"/><rect x="14" y="3" width="7" height="7" transform="rotate(45 17.5 6.5)"/></svg>
          <div class="w-6 h-[1px] bg-[#600b0b]/20"></div>
        </div>
        <div class="text-sm text-gray-700 space-y-0.5">
          <p>For any information,</p>
          <p>Contact us at <strong>+91-9810223204</strong> or</p>
          <p>Mail us at <a href="mailto:support@mahattaart.com" class="text-[#600b0b] font-semibold hover:underline">support@mahattaart.com</a></p>
        </div>
      </div>

    </div>
  </section>
</div>
